module.exports = __webpack_public_path__ + "img/byfoam.565d40cf.jpg";